<img class=" grid_item" [src]="assetsImage">